export default function() {
    Cookies.set("selected_donor", '');

    $(document).on('change', '#import-csv', function(){
        let file_csv = $(this).prop("files")[0];
        if(file_csv){
            $(this).parent().addClass('has-file');
            let info = $(this).parent().find('.file-input-info');
            info.find('.file-name').html(file_csv.name);
            info.find('.file-size').html(file_csv.size + ' bytes');
            info.find('.file-type').html(file_csv.type);
        }
    });

    $(document).on('click', '.remove-input-file', function(e){
        e.stopPropagation();
        e.stopImmediatePropagation();
        $('#import-csv').val('');
        $(this).parent().removeClass('has-file');
    });

    $(document).on('click', '.open-diario', function(e){
        e.stopPropagation();
        e.stopImmediatePropagation();
        $.ajax({
            url: "/ajax/get-diario",
            method: "POST",
            data: {
                'off_cod': $(this).data('off-codice')
            },
            success: function(response){
                if(response.success){
                    $('#show-data-off').find('.modal-title').text('Diario');
                    $('#show-data-off').find('.modal-body').html(response.html);
                    $('#show-data-off').modal('show');
                }
            }
        })
    });

    $(document).on('click', '.open-sinottico', function(e){
        e.stopPropagation();
        e.stopImmediatePropagation();
        $.ajax({
            url: "/ajax/get-sinottico",
            method: "POST",
            data: {
                'off_cod': $(this).data('off-codice')
            },
            success: function(response){
                if(response.success){
                    $('#show-data-off').find('.modal-title').text('Sinottico');
                    $('#show-data-off').find('.modal-body').html(response.html);
                    $('#show-data-off').modal('show');
                }
            }
        })
    });

    $(document).on('click', '.file-import-area .btn-backend', function(){
        $('.loader-container').removeClass('d-none');
        let file_csv = $('#import-csv').prop("files")[0];
        $(this).addClass('disabled');
        $('.remove-input-file').addClass('disabled');
        let form_data = new FormData();
        form_data.append("file_csv", file_csv)
        $.ajax({
            'method': 'POST',
            'url': '/ajax/import-donors',
            'data': form_data,
            'contentType': false,
            'processData': false,
            success: function(response){
                if(response.success){
                    $('#import-csv').val('');
                    $('.file-import-area').removeClass('has-file');
                    let success_msg = "Hai importato con successo la lista di donatori!";
                    let icon = 'success';
                    let title = 'Operazione riuscita';
                    if(response.exceptions.flag_exception){
                        title = '';
                        success_msg = "Hai importato correttamente la lista di donatori, tuttavia alcuni codici non esistono oppure sono già stati importati, a seguire la lista dei codici offerente non importati:</br>";
                        icon = "warning";
                        for(let elem of response.exceptions.off){
                            success_msg += '<strong>' + elem + '</strong></br>';
                        }
                    } else {
                        success_msg = "Hai importato con successo la lista di donatori!";
                    }
                    Swal.fire({
                        title: title,
                        html: success_msg,
                        icon: icon,
                    });
                } else {
                    Swal.fire({
                        title: 'Si è verificato un problema',
                        text: 'Non è stato possibile importare la lista di donatori selezionata!',
                        icon: 'error',
                    });
                }
                $('.file-import-area .btn-backend').removeClass('disabled');
                $('.remove-input-file').removeClass('disabled');
                $('.loader-container').addClass('d-none');
            },
            error: function(error){
                $('.file-import-area .btn-backend').removeClass('disabled');
                $('.remove-input-file').removeClass('disabled');
                $('.loader-container').addClass('d-none');
                Swal.fire({
                    title: 'Si è verificato un problema',
                    text: 'Non è stato possibile importare la lista di donatori selezionata!',
                    icon: 'error',
                });
            }
        });
    });

    $(document).on('change', '[name="import_only_lot"]', function(){
        if($('[name="import_only_lot"]').val() != ''){
            $('.refresh-select-picker').removeClass('d-none');
        } else {
            $('.refresh-select-picker').addClass('d-none');
        }
    });
    $(document).on('click', '.refresh-select-picker', function(){
        $('[name="import_only_lot"]').val('').selectpicker('refresh');
        $(this).addClass('d-none');
    });



    

    $(document).on('click', '.refresh-all-filter', function(){
        
        $('[name="import_lot"]').val('').selectpicker('refresh');
        $('[name="off_code_search"]').val('');
        $('[name="donor_name"]').val('');
        $('[name="donor_surname"]').val('');
        $('[name="donor_email"]').val('');
        $('[name="donor_donated"]').val('');
        $('[name="start_date"]').val('');
        $('[name="end_date"]').val('');
        $('[name="status_donor"]').val('');
        $('[name="minimum_rfm"]').val('');
        $('[name="donor_type"]').val('');
    });

    $(document).on('click', '.btn-remove-selected', function(){
        $('.selected').removeClass('selected');
        Cookies.set('selected_donor', '');
        $('.btn-import-selected-group').addClass('d-none');
    });

    $(document).on('click', '.btn-import', function(){
        $('.loader-container').removeClass('d-none');
        let donors = Cookies.get('selected_donor').split('::');
        $.ajax({
            'url': '/ajax/import-donors-datatable',
            'method': 'POST',
            'data': {
                'donors': donors
            },
            success: function(response){
                if(response.success){
                    Swal.fire({
                        title: 'Operazione riuscita',
                        text: donors.length > 1 ? 'Hai importato correttamente i donatori' : 'Hai importato correttamente il donatore',
                        icon: 'success',
                    });
                    $('.btn-import-selected-group').addClass('d-none');
                    Cookies.set('selected_donor', '');
                    $('#off-table').DataTable().ajax.reload();
                } else {
                    Swal.fire({
                        title: 'Si è verificato un problema',
                        text: donors.length > 1 ? 'Non è stato possibile importare i donatori indicati!' : 'Non è stato possibile importare il donatore indicato!',
                        icon: 'success',
                    });
                }
                $('.loader-container').addClass('d-none');
            },
            error: function(error){
                $('.loader-container').addClass('d-none');
                Swal.fire({
                    title: 'Si è verificato un problema',
                    text: donors.length > 1 ? 'Non è stato possibile importare i donatori indicati!' : 'Non è stato possibile importare il donatore indicato!',
                    icon: 'success',
                });
            }
        });
    });

    var table = $('#off-table').DataTable({
        processing: true,
        serverSide: true,
        responsive: true,
        ajax: {
            'url': '/datatables/off',
            'type': 'GET',
            'data': function( p ) {
                p.off_code = $('.filter-form [name="off_code_search"]').val();
                p.name = $('.filter-form [name="donor_name"]').val();
                p.surname = $('.filter-form [name="donor_surname"]').val();
                p.email = $('.filter-form [name="donor_email"]').val();
                p.donated = $('.filter-form [name="donor_donated"]').val();
                p.start_date = $('.filter-form [name="start_date"]').val();
                p.end_date = $('.filter-form [name="end_date"]').val();
                p.status_donor = $('.filter-form [name="status_donor"]').val();
                p.import_lot = $('.filter-form [name="import_lot"]').val();
                p.minimum_rfm = $('[name="minimum_rfm"]').val();
                p.rfm = $('[name="max_rfm"]').val();
                p.org_sn = $('[name="donor_type"]').val();
            },
            "dataSrc": function(json) {
                $('.loader-container').addClass('d-none');
                return json.data;
            }
        },
        columns: [
            {name: 'off_codice', data: 'Off_Codice', visible: false},
            {name: 'is_org', data: 'Off_NucleoSN', width: '5%'},
            {name: 'diario', data: 'diario', width: '5%'},
            {name: 'sinottico', data: 'sinottico', width: '5%'},
            {name: 'surname', data: 'Off_Ana1', width: '15%'},
            {name: 'name', data: 'Off_Ana2', width: '15%'},
            {name: 'email', data: 'Off_Email', width: '15%'},
            {name: 'donated', data: 'total_donated', width: '15%'},
            {name: 'status', data: 'TStOff_Descrizione', width: '15%'},
            {name: 'rfm', data: 'Off_RFM', width: '10%'},
        ],
        rowCallback: function( row, data ) {
            let selected_donors = Cookies.get('selected_donor');
            let selected_donors_array = selected_donors.split('::');
            for(let index in selected_donors_array){
                if(selected_donors_array[index] == data.Off_Codice){
                    $(row).addClass('selected');
                }
            }
        },
        language: {
            "sLengthMenu": "_MENU_ Donatori per pagina",
            "sZeroRecords": "Nessun Donatore",
            "sInfo": "Mostra da _START_ a _END_ di _TOTAL_ Donatori",
            "sInfoEmpty": "0 di 0 su 0 Donatori",
            "sInfoFiltered": "(Filtrati _MAX_ Donatori)",
            "sInfoPostFix": "",
            "sSearch": "Cerca",
            "oPaginate": {
                "sFirst":    "Inizio",
                "sPrevious": "Indietro",
                "sNext":     "Avanti",
                "sLast":     "Fine"
            }
        },
    });

    $(document).on('click', '#import_full_lot', function(e) {
        if ($('[name="import_only_lot"]').val() == '') {
            Swal.fire({
                title: 'Attenzione',
                text: 'Devi scegliere un lotto da importare',
                icon: 'warning',
            });
            return;
        }
        $.ajax({
            'url': '/ajax/import-lot-datatable',
            'method': 'POST',
            'data': {
                'id_lot': $('[name="import_only_lot"]').val()
            },
            success: function(response){
                if(response.success){
                    Swal.fire({
                        title: 'Operazione riuscita',
                        text: 'Hai importato correttamente il lotto',
                        icon: 'success',
                    });
                } else {
                    Swal.fire({
                        title: 'Si è verificato un problema',
                        text: 'Non è stato possibile importare il lotto indicato!',
                        icon: 'success',
                    });
                }
            },
            error: function(error){

            }
        });
    });

    $(document).on('click', '#start_search', function(e)  {
        console.log('Cerca button clicked');
        $('.loader-container').removeClass('d-none');
        Cookies.set('selected_donor', '');
        table.ajax.reload();
    });

    table.on('click', 'tbody tr', function (event) {
        var target = $(event.target);
        if (target.closest('.no-click').length) {
            return 0;
        }

        let data = $('#off-table').DataTable().row(this).data();
        let selected_donors = Cookies.get('selected_donor');
        Cookies.remove('selected_donor')
        if(!selected_donors){
            selected_donors = '';
        }
        if($(this).hasClass('selected')){
            $(this).removeClass('selected');
            let selected_donors_array = selected_donors.split('::');
            let output_str = '';
            let is_first = true;
            let new_array = [];
            for(let index in selected_donors_array){
                if(selected_donors_array[index] != data["Off_Codice"]){
                    new_array.push(selected_donors_array[index])
                }
            }
            selected_donors_array = new_array;
            for(let index in selected_donors_array){
                if(!is_first){
                    output_str += '::' + selected_donors_array[index];
                } else {
                    is_first = false;
                    output_str = selected_donors_array[index];
                }
            }
            selected_donors = output_str;
        } else {
            $(this).addClass('selected');
            if(selected_donors == ''){
                selected_donors = data["Off_Codice"];
            } else {
                selected_donors = selected_donors + '::' + data["Off_Codice"];
            }
        }
        Cookies.set('selected_donor', selected_donors);
        if(selected_donors != ''){
            $('.btn-import-selected-group').removeClass('d-none');
        } else {
            $('.btn-import-selected-group').addClass('d-none');
        }
    });
}